import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../components/Button";
import PetList from "../components/PetList";
import { getInfo } from "../services/api";

// const heroImg = new URL("../assets/images/hero.jpg", import.meta.url);
const heroImg = new URL("../assets/images/hero2.jpg", import.meta.url);
const europeShelterImg = new URL("../assets/images/europe-shelter.svg", import.meta.url);

export default function Index() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("index");
    void getInfo();
  }, []);

  return (
    <>
      <div className="container mx-auto pb-8">
        <div className="px-5">
          <div className="relative h-[400px] overflow-hidden">
            <div className="absolute z-10 h-full w-full">
              <div className="grid h-full w-full grid-cols-2">
                <div className="flex flex-col justify-center gap-4 p-14">
                  <div className="text-theme-orange-5">2 dog shelters, 8 dogs</div>
                  <div className="max-w-[480px] font-simianregular text-[40px] leading-none text-white">
                    Find your perfect rescue dog – easier than ever
                  </div>
                  <div>
                    <Button title="Learn more" border={true} onClick={() => navigate("/about")} />
                  </div>
                </div>

                <div className="flex justify-end p-8 text-theme-white">
                  <div className="flex w-[200px] flex-col items-center gap-2">
                    <img className="w-[124px]" src={europeShelterImg.href} />
                    <div className="text-right text-label-regular">
                      Europe's leading dog shelter hub
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <img
              className="block h-full w-full rounded-[16px] object-cover object-center"
              src={heroImg.href}
              alt="tailtales adopt from dog shelters worldwide"
            />
          </div>
        </div>
        <PetList gridWrapperCss="rounded-[8px] bg-theme-white" />
      </div>
    </>
  );
}
